/* eslint-disable camelcase */
import styled from 'styled-components'
import moment from 'moment'
import React, { Component } from 'react'
import formatToCurrency from 'portuguese-utils/formaters/formatToCurrency'
import {
  TITLES,
  MERCHANT_IDENTIFICATION,
  COMERCIAL_CONDITIONS,
  ADDITIONAL_SERVICES,
  REFUNDS_ENTRIES,
  SUPPORT_OPTIONS,
  BILLING_TYPE,
  CONTRACT_TYPE,
  PAYMENT_TYPE,
  ADDITIONAL_RESTRICTIONS,
} from './information-entries'
import { Marginer } from 'components/Util'
import Tabs from 'components/Tabs'
import MonthlyInvoice from 'components/MonthlyInvoice'
import { roundToTwo } from 'utils'
import { getResolvedWebsite, SIMPLE_WEBSITE_REGEX } from '../../utils'

// Modalidade da oferta comercial: commercial_offer_modality
const processIdentification = (
  { designation, description },
  {
    market_segment_type,
    commercial_offer_website,
    website_standardized_contract_form,
    website_contract_conditions,
    contacts,
    email_contact,
    website_contact,
  },
  segments
) => ({
  designation,
  description,
  commercial_offer_website,
  website_standardized_contract_form,
  website_contract_conditions,
  contacts,
  email_contact,
  website_contact,
})

const processComercial = (
  {
    offer_type,

    additional_services,
  },
  {
    contract_duration,
    offer_start_date,
    offer_validity,
    email_contract_contact,
    location_contract_contact,
    phone_contract_contact,
    electronic_billing,
    green_energy,
    paper_billing,
    direct_debit,
    atm_ctt,
    shop_payment,
    support_options,
    payment_periodicity,
    loyalty_clauses_description,
    has_additional_restrictions,
    additional_restrictions,
    offer_restrictions,
    discount_as_uploaded,
    price_function_of_access,
    price_revision_conditions,
    indexed_prices,
    indexed_prices_description,
    website_contract_contact,
  }
) => {
  const newObj = {
    contract_duration,
    offer_start_date: offer_start_date
      ? moment(new Date(offer_start_date)).format('DD/MM/YYYY')
      : '',
    offer_validity: offer_validity
      ? moment(new Date(offer_validity)).format('DD/MM/YYYY')
      : '',
    contract_type: [
      email_contract_contact || website_contract_contact ? (
        email_contract_contact ? (
          <Link href={`mailto:${email_contract_contact}`} target='_blank'>
            {CONTRACT_TYPE.email_contract_contact}
          </Link>
        ) : (
          <Link href={website_contract_contact} target='_blank'>
            {CONTRACT_TYPE.email_contract_contact}
          </Link>
        )
      ) : (
        ''
      ),
      location_contract_contact ? (
        <Link href={`${location_contract_contact}`} target='_blank'>
          {CONTRACT_TYPE.location_contract_contact}
        </Link>
      ) : (
        ''
      ),
      phone_contract_contact ? (
        <Link href={`tel:${phone_contract_contact}`} target='_blank'>
          {CONTRACT_TYPE.phone_contract_contact} ({phone_contract_contact})
        </Link>
      ) : (
        ''
      ),
    ].filter((d) => d),
    billing_type: [
      electronic_billing ? BILLING_TYPE.electronic_billing : '',
      paper_billing ? BILLING_TYPE.paper_billing : '',
    ]
      .filter((d) => d)
      .join(', '),
    payment_type: [
      direct_debit ? PAYMENT_TYPE.direct_debit : '',
      atm_ctt ? PAYMENT_TYPE.atm_ctt : '',
      shop_payment ? PAYMENT_TYPE.shop_payment : '',
    ]
      .filter((d) => d)
      .join(', '),
    support_options:
      support_options &&
      support_options
        .map((so) => SUPPORT_OPTIONS.find((sup) => sup.slug === so).text)
        .join(', '),
    payment_periodicity,
    has_loyalty: !!additional_services.find((d) => d.id === 3),
    loyalty_clauses_description,
    green_energy,
    has_additional_restrictions,
    additional_restrictions:
      additional_restrictions &&
      additional_restrictions.map((d) => ADDITIONAL_RESTRICTIONS[d]),
    offer_restrictions,
    discount_as_uploaded,
    price_function_of_access,
    price_revision_conditions,
    indexed_prices,
    indexed_prices_description,
  }

  if (!newObj.has_loyalty) {
    delete newObj.loyalty_clauses_description
  }

  if (!has_additional_restrictions) {
    delete newObj.additional_restrictions
  } else {
    delete newObj.has_additional_restrictions
  }

  if (!indexed_prices) {
    delete newObj.indexed_prices_description
  }

  return newObj
}

const entriesObject = {
  electric: {
    currentEntityElectric: { value: '', valid: false, designation: 'ee' },
    cpe: { value: '', valid: false },
    potency: { value: '', valid: false },
    cycle: { value: '', valid: false, designation: 'CYCLE' },
  },

  gas: {
    currentEntityGas: { value: '', valid: false, designation: 'eg' },
    cui: { value: '', valid: false },
    tier: { value: '', valid: false, designation: 'TIER' },
  },
}

const processAdditionalServices = (
  {
    additional_services_cost,
    additional_services_cost_with_vat,
    additional_services_description,
    optional_services_description,
  },
  { additional_services }
) => {
  const newObj = {
    required_subscription_additional_services: !!additional_services.find(
      (d) => d.id === 5
    ),
    additional_services_cost: additional_services_cost
      ? `${formatToCurrency(additional_services_cost, 2)}`
      : '',
    additional_services_cost_with_vat: additional_services_cost_with_vat
      ? `${formatToCurrency(additional_services_cost_with_vat, 2)}`
      : '',
    additional_services_description,
    optional_services_description,
  }

  if (!newObj.required_subscription_additional_services) {
    delete newObj.additional_services_cost_with_vat
    delete newObj.additional_services_description
  }

  return newObj
}

const processRefunds = ({
  has_refunds,
  annual_refunds,
  electricity_refund_fixed_term,
  electricity_refund_energy_term,
  electricity_refund_energy_function,
  gas_refund_fixed_term,
  gas_refund_energy_term,
  gas_refund_energy_function,
  refunds_description,
}) => {
  if (!has_refunds) {
    return { has_refunds }
  }
  const newObj = {
    has_refunds,
    annual_refunds: annual_refunds
      ? `${formatToCurrency(annual_refunds, 2)}`
      : '',
    electricity_refund_fixed_term: electricity_refund_fixed_term
      ? `${roundToTwo(electricity_refund_fixed_term * 100)}%`
      : ``,
    electricity_refund_energy_term: electricity_refund_energy_term
      ? `${roundToTwo(electricity_refund_energy_term * 100)}%`
      : ``,
    electricity_refund_energy_function: electricity_refund_energy_function
      ? `${formatToCurrency(electricity_refund_energy_function, 4)}`
      : '',
    gas_refund_fixed_term: gas_refund_fixed_term
      ? `${roundToTwo(gas_refund_fixed_term * 100)}%`
      : ``,
    gas_refund_energy_term: gas_refund_energy_term
      ? `${roundToTwo(gas_refund_energy_term * 100)}%`
      : ``,
    gas_refund_energy_function: gas_refund_energy_function
      ? `${formatToCurrency(gas_refund_energy_function, 4)}`
      : '',
    refunds_description,
  }

  Object.keys(newObj).forEach((key) => {
    if (newObj[key] === '' || newObj[key] === null) {
      delete newObj[key]
    }
  })

  return newObj
}

const typeOfVariable = (val) => {
  if (typeof val === 'boolean') {
    return val ? 'Sim' : 'Não'
  }

  if (typeof val === 'string') {
    if (SIMPLE_WEBSITE_REGEX.test(val)) {
      const urls = val.match(SIMPLE_WEBSITE_REGEX)
      const normalTexts = val.split(SIMPLE_WEBSITE_REGEX)

      return normalTexts.reduce((arr, value, i) => {
        const isEmail = /[\w-]+@$/.test(value)

        const url = urls.length >= i + 1 ? urls[i] : ''

        if (value)
          arr.push(
            <EntryText>
              {value}
              {isEmail ? url : ''}
            </EntryText>
          )

        if (!isEmail && url)
          arr.push(
            <Link href={getResolvedWebsite(urls[i])} target='_blank'>
              {urls[i]}
            </Link>
          )

        return arr
      }, [])
    }
    return val || '---'
  }
  if (Array.isArray(val)) {
    return val.map((v) => (
      <span>
        {v}
        <br />
      </span>
    ))
  }

  return val
}

const Entry = (props) => (
  <EntryText>
    {props.value === undefined || props.value === null
      ? '---'
      : typeOfVariable(props.value)}
  </EntryText>
)

const renderIdentificationLabels = (identification, entry) => {
  if (entry === 'website_contact' || entry === 'email_contact') {
    if (
      !identification['website_contact'] &&
      !identification['email_contact']
    ) {
      return (
        <InfoEntry key={'website_contact'}>
          <EntryLabel xs={7}>
            {MERCHANT_IDENTIFICATION['website_contact']}
          </EntryLabel>
          <Entry value={identification['website_contact']} />
        </InfoEntry>
      )
    } else {
      if (identification[entry]) {
        return (
          <InfoEntry key={entry}>
            <EntryLabel xs={7}>{MERCHANT_IDENTIFICATION[entry]}</EntryLabel>
            <Entry value={identification[entry]} />
          </InfoEntry>
        )
      }
    }
  } else {
    return (
      <InfoEntry key={entry}>
        <EntryLabel xs={7}>{MERCHANT_IDENTIFICATION[entry]}</EntryLabel>
        <Entry value={identification[entry]} />
      </InfoEntry>
    )
  }
}

class TariffDetails extends Component {
  state = {
    index: 0,
  }

  render() {
    const { tariff, priceListTimeCycle, resultTariff } = this.props

    if (priceListTimeCycle) {
      entriesObject.electric.tariff = {
        value: priceListTimeCycle,
        valid: true,
        designation: 'TARIFF',
      }
    }

    const { index } = this.state
    const tabs = ['Detalhes', 'Fatura Mensal']
    let pricelistadditionalinfo
    if (tariff) {
      pricelistadditionalinfo = tariff.pricelistadditionalinfo
    }

    const tabChange = (index) => {
      this.setState({ index: index })
      return index
    }

    const identification = processIdentification(
      tariff,
      pricelistadditionalinfo
    )
    const comercial = processComercial(tariff, pricelistadditionalinfo)
    const addServices = processAdditionalServices(
      pricelistadditionalinfo,
      tariff
    )
    const refunds = processRefunds(pricelistadditionalinfo)

    return (
      <Container>
        <Tabs
          currentIndex={index}
          tabs={tabs}
          hasProgress
          onClick={tabChange}
        />
        {index === 0 && (
          <div>
            {tariff && (
              <div>
                <Marginer top={32}>
                  <Title className='mt-3'>{TITLES.IDENTIFICATION}</Title>
                </Marginer>
                {Object.keys(identification).map((entry) =>
                  renderIdentificationLabels(identification, entry)
                )}
                <Marginer top={32}>
                  <Title className='mt-3'>{TITLES.COMERCIAL_CONDITIONS}</Title>
                </Marginer>
                {Object.keys(comercial).map((entry) => (
                  <InfoEntry key={entry}>
                    <EntryLabel xs={7}>
                      {COMERCIAL_CONDITIONS[entry]}
                    </EntryLabel>
                    <Entry value={comercial[entry]} />
                  </InfoEntry>
                ))}
                <Marginer top={32}>
                  <Title className='mt-3'>{TITLES.ADDITIONAL_SERVICES}</Title>
                </Marginer>
                {Object.keys(addServices).map((entry) => (
                  <InfoEntry key={entry}>
                    <EntryLabel xs={7}>{ADDITIONAL_SERVICES[entry]}</EntryLabel>
                    <Entry value={addServices[entry]} />
                  </InfoEntry>
                ))}
                <Marginer top={32}>
                  <Title className='mt-3'>{TITLES.REFUNDS}</Title>
                </Marginer>
                {Object.keys(refunds).map((entry) => (
                  <InfoEntry key={entry}>
                    <EntryLabel xs={7}>{REFUNDS_ENTRIES[entry]}</EntryLabel>
                    <Entry value={refunds[entry]} />
                  </InfoEntry>
                ))}
              </div>
            )}
          </div>
        )}
        {index === 1 && (
          <TariffWrapper>
            <MonthlyInvoice
              tariff={resultTariff}
              tariffInfo={tariff}
              entries={entriesObject}
            />
          </TariffWrapper>
        )}
      </Container>
    )
  }
}

const Container = styled.div`
  padding-bottom: 32px;
  max-height: calc(100vh - 300px);
  overflow-y: auto;
  overflow-x: hidden;
  min-height: calc(100vh - 500px);
`

const TariffWrapper = styled.div`
  padding: 10px;
`

const Title = styled.h6`
  color: #93c13e;
  font-family: Nunito;
  font-size: 16px;
  font-weight: 600;
  line-height: 16px;
  margin: 0;
`

const InfoEntry = styled.div`
  display: flex;
  margin-top: 16px;
  border-bottom: 1px solid #efefef;
  padding-bottom: 4px;

  @media (max-width: 860px) {
    flex-direction: column;
  }
`

const EntryLabel = styled.span`
  color: #9c9c9c;
  font-family: Nunito;
  font-size: 14px;
  font-weight: 600;
  line-height: 14px;
  min-width: 40%;
  max-width: 40%;
  margin-right: 8px;

  @media (max-width: 860px) {
    margin-bottom: 8px;
  }
`

const EntryText = styled.span`
  color: #3e3e3e;
  font-family: Nunito;
  font-size: 14px;
  font-weight: 600;
  line-height: 14px;
  white-space: pre-wrap;
`

const Link = styled.a`
  word-wrap: 'break-word';
  color: #93c13e;
`

export default TariffDetails



// WEBPACK FOOTER //
// ./src/components/TariffDetails/index.js